import { NotificationCounter } from './Notification';
import './HeaderActions.css';
import { useAppSelector } from 'store/hook';
import TimezoneMenu from './TimezoneMenu';
import { TirePressureNotificationCounter } from './TirePressureNotification';
import { DtcNotificationCounter } from './DtcNotification';
import { useRouteExists } from 'components/Route/useRouteExists';
import { CustomerInfo } from './CustomerInfo';
import ProfileButton from './UserProfileSection';
import DownloadDropdown from './DownloadDropdown';

const HeaderActions = () => {
  const role = useAppSelector((state) => state.authReducer.role);

  const isNotificationVisible = useRouteExists({
    id: 'notifications',
    forSidebar: false,
  });

  const isTirePressureNotificationVisible = useRouteExists({
    id: 'tireAnalytics',
    forSidebar: false,
  });

  const isDtcNotificationVisible = useRouteExists({
    id: 'dtcSummary',
    forSidebar: false,
  });

  if (role === null) {
    return <></>;
  }

  return (
    <div className="header-actions">
      {/* Timezone Selector */}
      <DownloadDropdown />
      <TimezoneMenu />
      {/* <ThemeToggle /> */}
      {isTirePressureNotificationVisible && <TirePressureNotificationCounter />}
      {isDtcNotificationVisible && <DtcNotificationCounter />}
      {isNotificationVisible && <NotificationCounter />}
      {role && <CustomerInfo role={role} />}
      <ProfileButton />
    </div>
  );
};

export default HeaderActions;
